import { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { SOURCE } from "@/constants";
import Fallback from "@/containers/MentionCard/partials/Cover/partials/Fallback";

let instagramIsInititalized = "";

import { cx } from "@/utils";

import styles from "../Cover.module.css";

const InstagramCover = ({ episodeUrl, ...props }) => {
  const { location } = useHistory();

  // Start loading instagram posts when the user is 300px away from them,
  // avoiding blasting away all requests at once

  useEffect(() => {
    // Look for Instagram oembed div's
    // when loaded and rendered

    // make sure embed process is not called more than once even though there are multiple IG elements on screen
    if (instagramIsInititalized !== location) {
      try {
        window.instgrm?.Embeds.process();
      } catch {
        // Instagram sometimes throw errors when called multiple times. supress them.
      }
    }
    instagramIsInititalized = location;
  }, [location]);

  return (
    <div className={styles.instagram} {...props}>
      <blockquote
        className={cx("instagram-media", "instagram-embed")}
        data-instgrm-permalink={`${episodeUrl}?utm_source=ig_embed`}
        data-instgrm-version="14"
      />
      <Fallback source={SOURCE.INSTAGRAM} className="fallback" />
    </div>
  );
};

export default InstagramCover;
